import { useCallback, useMemo } from 'react';

import type { PerimeterXEnforcerChallenge } from '@change-corgi/core/perimeterx';
import { useTracking } from '@change-corgi/core-react/tracking';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Result = Readonly<{
	trackSuccess: (pxResponse: PerimeterXEnforcerChallenge) => void;
	trackFailure: (pxResponse: PerimeterXEnforcerChallenge) => void;
}>;

export function usePerimeterXTracking(): Result {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();

	const getProps = useCallback(
		(pxResponse: PerimeterXEnforcerChallenge): TrackingProperties => ({
			form: 'corgi_sign',
			pxRefId: pxResponse.uuid,
			pxVid: pxResponse.vid,
			petition_id: petitionId,
		}),
		[petitionId],
	);

	return useMemo(
		() => ({
			trackSuccess: (pxResponse: PerimeterXEnforcerChallenge) => {
				void track('px_captcha_solved', getProps(pxResponse));
			},
			trackFailure: (pxResponse: PerimeterXEnforcerChallenge) => {
				void track('px_captcha_failed', getProps(pxResponse));
			},
		}),
		[track, getProps],
	);
}
